import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { Sparkles, Gift, CheckCircle, ArrowRight, ArrowLeft } from 'lucide-react';
import '../styles/lpu.css';

export default function LPUFaculty() {
  return (
    <div className="modern-theme-wrapper lpu-faculty-page">
      <div style={{ position: 'absolute', top: '20px', left: '20px', zIndex: 10 }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 16px', background: 'rgba(255,255,255,0.9)', borderRadius: '8px', color: '#1e3a8a', textDecoration: 'none', fontWeight: '600', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', backdropFilter: 'blur(10px)' }}>
          <ArrowLeft size={18} /> Back to Home
        </Link>
      </div>
      <main>
        {/* Hero Section */}
        <section className="lpu-hero" style={{ paddingTop: '80px' }}>
          <div style={{ maxWidth: '1000px', width: '100%', textAlign: 'center' }}>
            <div className="lpu-exclusive-badge">
              <img src="/lpu logo.png" alt="LPU" style={{ height: '24px' }} />
              <span>EXCLUSIVE FACULTY OFFER</span>
            </div>
            
            <h1 className="lpu-hero-title">
              Hello LPU Faculty,<br />
              Welcome to{' '}
              <span className="lpu-brand-teach" style={{ color: '#1e3a8a' }}>Teach</span>
              <span className="lpu-brand-genie" style={{ color: '#f59e0b' }}>Genie<sup>™</sup></span>
              <span className="lpu-brand-ai" style={{ color: '#1e3a8a' }}>.ai</span>
            </h1>
            
            <p style={{
              fontSize: '1.35rem',
              fontWeight: '800',
              color: '#f59e0b',
              margin: '16px 0 24px',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              fontStyle: 'italic',
              textShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              "Celebrate Teacher's Day, Everyday"
            </p>
            
            <p className="lpu-hero-subtitle">
              We're honored to support the brilliant educators at Lovely Professional University. Enrich your teaching with AI-powered lesson planning, customized just for you.
            </p>

            {/* Offer Card */}
            <div className="lpu-offer-card" style={{ maxWidth: '900px' }}>
              <div style={{ textAlign: 'left', flex: '1 1 300px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <Gift color="#f59e0b" size={24} />
                  <span style={{ fontWeight: '700', color: '#f59e0b', fontSize: '1.1rem' }}>SPECIAL GIFT</span>
                </div>
                <h2 className="lpu-offer-title">Silver Tier - T26271</h2>
                <ul className="lpu-feat-list">
                  {[
                    '30 Monthly Generations',
                    'Advanced AI Orchestration',
                    'High-Complexity UG Lessons',
                    'PPT & PDF Export Included',
                    'Excercises and Scenario Quizzes'
                  ].map((feat, i) => (
                    <li key={i} className="lpu-feat-item">
                      <CheckCircle size={18} color="#10B981" />
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div style={{ flex: '0 0 250px' }}>
                <div style={{ position: 'relative' }}>
                  <img src="/silver.png" alt="Silver Tier" style={{ width: '100%', height: 'auto', transform: 'rotate(-5deg)' }} />
                  <div className="lpu-price-tag">
                    ₹0 / MONTH
                  </div>
                </div>
                <Link to="/lpu/register" style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  background: 'linear-gradient(135deg, #1e3a8a 0%, #f59e0b 100%)',
                  color: 'white',
                  padding: '16px 24px',
                  borderRadius: '16px',
                  textDecoration: 'none',
                  fontWeight: '700',
                  marginTop: '24px',
                  cursor: 'pointer',
                  boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                className="lpu-claim-btn"
                >
                  Claim My Access <ArrowRight size={20} />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits for Faculty */}
        <section className="lpu-benefits">
          <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
            <h2 className="lpu-section-title">Designed for Academic Excellence</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
              {[
                { title: 'Save Hours', desc: 'Generate complete 60-minute UG lesson plans in minutes, not hours.', icon: <Sparkles /> },
                { title: 'Interactive Content', desc: 'Automatically include quizzes, case studies, and dynamic subsections.', icon: <Sparkles /> },
                { title: 'Ready to Present', desc: 'Instantly download professional PowerPoint presentations for your lectures.', icon: <Sparkles /> }
              ].map((benefit, i) => (
                <div key={i} className="lpu-benefit-card">
                  <div style={{ color: '#f59e0b', marginBottom: '16px' }}>{benefit.icon}</div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      
      <style>{`
        .hover-lift:hover {
          transform: translateY(-4px);
          box-shadow: 0 15px 30px rgba(30, 58, 138, 0.3) !important;
        }
      `}</style>
    </div>
  );
}
